module.exports = __webpack_public_path__ + "media/newstyle/images/icon-seu-livro-bok2-ccde7c412257cec6cb90b00f6bd4a2c8.png";